<template>
    <el-dialog
        title="Download Data"
        :visible.sync="showForm"
        append-to-body
    >
        <div>Please select data to include in the CSV:</div>

        <div v-for="o in options">
            <el-checkbox v-model="data[o.id]" :true-label="1" :false-label="0">{{ o.name }}</el-checkbox>
        </div>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="download">Download</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: [
        'show',
        'employer_id',
        'driver_upload_id'
    ],
    data() {
        let options = [
            {id: 'driver_id', name: 'Driver ID', default_checked: true},
            {id: 'employer_id', name: 'Employer ID', default_checked: false},
            {id: 'job_id', name: 'Job ID', default_checked: false},

            {id: 'app_type_all', name: 'Lead Type (all)', default_checked: true},
            {id: 'app_type_first', name: 'Lead Type (first)', default_checked: true},
            {id: 'app_type_last', name: 'Lead Type (last)', default_checked: false},

            {id: 'first_app_date', name: 'Lead Date', default_checked: true},
            {id: 'spend', name: 'Price', default_checked: true},
            {id: 'referrers', name: 'Referrer', default_checked: true},
            {id: 'cdl_xp_text_last', name: 'Experience (last)', default_checked: true},
            {id: 'cdl_xp_text_all', name: 'Experience (all)', default_checked: false},
            {id: 'cdl_a_months_driven', name: 'Experience in last 3 years', default_checked: true},

            {id: 'paid_media_source', name: 'Source (all)', default_checked: true},
            {id: 'jobadviser_name', name: 'JA Name (all)', default_checked: true},
            {id: 'call_length', name: 'Call Length (all)', default_checked: true},

            {id: 'ja_call_date', name: 'JA Call Date', default_checked: false},
            {id: 'ooha_now', name: 'Is lead OOHA now?', default_checked: false},
            {id: 'ooha_when_sent', name: 'Was lead OOHA when sent?', default_checked: false},
        ];

        let data = {};
        _.each(options, t => {
            data[t.id] = t.default_checked ? 1 : 0;
        });

        return {
            options: options,
            data: data
        };
    },
    computed: {
        showForm: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('close');
            }
        }
    },
    methods: {
        download() {
            let url_params = $.param(this.data);
            window.location.href = url(`admin/employer/${this.employer_id}/lead-validation/${this.driver_upload_id}/download`) + '?' + url_params;
        }
    },
    mounted() {
    }
}
</script>

<style>
</style>
